const a = "_heading_h1aqr_20", r = "_description_h1aqr_24", l = {
  "bmi-calculator": "_bmi-calculator_h1aqr_1",
  "bmi-calculator--form": "_bmi-calculator--form_h1aqr_15",
  "bmi-calculator--results": "_bmi-calculator--results_h1aqr_16",
  heading: a,
  description: r,
  "bmi-calculator--results-result": "_bmi-calculator--results-result_h1aqr_87",
  "bmi-calculator--range": "_bmi-calculator--range_h1aqr_111"
};
export {
  l as default,
  r as description,
  a as heading
};
